import { render, staticRenderFns } from "./regionSelect.vue?vue&type=template&id=5b34c93c&scoped=true"
import script from "./regionSelect.vue?vue&type=script&lang=js"
export * from "./regionSelect.vue?vue&type=script&lang=js"
import style0 from "./regionSelect.vue?vue&type=style&index=0&id=5b34c93c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b34c93c",
  null
  
)

export default component.exports